<template>
<div class="modal fade" id="session-local-form-modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header py-2 pe-2">
                <strong class="modal-title" id="erkModalLabel">ESPORTA</strong>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div v-if="isLoading">

                </div>
                <div v-else>
                    <form id="form-esporta" action="#" method="post">

                        <!-- Filtri checkbox -->
                        <div class="row g-lg-3 mb-3">
                            <div class="mb-2">
                                <div class="form-check">
                                    <input v-model="form.export_trend" type="checkbox" name="filter1" class="form-check-input" value="1" id="checkFilter1">
                                    <label class="form-check-label" for="checkFilter1">
                                        Andamento
                                    </label>
                                </div>
                            </div>
                            <div class="mb-2">
                                <div class="form-check">
                                    <input v-model="form.export_exercise" type="checkbox" name="filter3" class="form-check-input" value="3" id="checkFilter3">
                                    <label class="form-check-label" for="checkFilter3">
                                        Esercizi
                                    </label>
                                </div>
                            </div>
                            <div class="mb-2">
                                <div class="form-check">
                                    <input v-model="form.export_tachi" type="checkbox" name="filter3" class="form-check-input" value="3" id="checkFilter3">
                                    <label class="form-check-label" for="checkFilter3">
                                        Tachistoscopio
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Data inizio / Data fine -->
                        <div class="row g-lg-3 mb-3">
                            <div class="col">
                                <input v-model="form.date1" type="date" id="date1" name="date1" value="" class="form-control" required="">
                                <div class="invalid-feedback">Specificare data inizio</div>
                            </div>
                            <div class="col">
                                <input v-model="form.date2" type="date" id="date2" name="date2" value="" class="form-control" required="">
                                <div class="invalid-feedback">Specificare data fine</div>
                            </div>
                        </div>
                    </form>
                </div>

                <div v-if="!isLoading" class="modal-footer">
                    <button @click="onClickExport()" type="button" class="btn btn-primary close-btn" data-bs-toggle="modal" data-bs-dismiss="modal">
                        <span class="bi-download"></span>
                        Esporta
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>

export default{
    props: {
        userId: Number
    },
    data(){
        return {
            isLoading: false,
            form: {
                date1: null,
                date2: null,
                export_trend: true,
                export_summary: true,
                export_exercise: true,
                export_tachi: true
            }
        }
    },
    created(){
        let d = new Date()
        this.form.date2 = d.getFullYear() + "-" + this.formatMonth(d) + "-" + d.getDate()

        d.setMonth(d.getMonth() - 2)
        this.form.date1 = d.getFullYear() + "-" + this.formatMonth(d) + "-" + d.getDate()
    },
    mounted(){
    },
    methods: {
        formatMonth(date){
            let month = date.getMonth() + 1
            if (month < 10){
                return '0' + month
            }
            return month
        },
        toggle(){
            let myModal = new window.bootstrap.Modal(document.getElementById('session-local-form-modal'))
            myModal.toggle()
        },
        onClickExport(){
            let url = "/structure/student/report/ReportExportAction?userId=" + this.userId
                + "&date1=" + this.form.date1
                + "&date2=" + this.form.date2
                + "&export_trend=" + this.form.export_trend
                + "&export_summary=" + this.form.export_summary
                + "&export_exercise=" + this.form.export_exercise
                + "&export_tachi=" + this.form.export_tachi;
            window.open(url, '_blank')
        }
    }
}
</script>